import { renderRichText } from "./richTextMarkup";

/**
 * Master v5 Prompt 30C Phase 2 — read-only rendering of a typed input
 * block's current value. Shared identically by BlockCard.jsx (the
 * published client document, outside the editing state) and
 * ImportPreviewDialog.jsx (the coach's import preview, before
 * publish) — the same component a client sees is what the coach
 * previews, per §3 "use the actual existing ... same typed renderer
 * that the client document will use."
 */
export function TypedValuePreview({ inputType, value }) {
  if (inputType === "list") {
    const items = value || [];
    if (!items.length) return <span className="text-ink-soft italic">No items yet</span>;
    return <ul className="list-disc pl-5 text-sm text-ink space-y-0.5">{items.map((it) => <li key={it.id}>{it.text || <span className="text-ink-soft italic">(empty)</span>}</li>)}</ul>;
  }
  if (inputType === "checklist") {
    const items = value || [];
    if (!items.length) return <span className="text-ink-soft italic">No items yet</span>;
    return (
      <ul className="text-sm text-ink space-y-1">
        {items.map((it) => (
          <li key={it.id} className={`flex items-center gap-2 ${it.checked ? "text-ink-soft line-through" : ""}`}>
            <span className={`inline-block h-3.5 w-3.5 rounded-sm border ${it.checked ? "bg-terracotta border-terracotta" : "border-ink/30"}`} />
            {it.label || <span className="italic">(empty)</span>}
          </li>
        ))}
      </ul>
    );
  }
  if (inputType === "table") {
    const rows = value?.rows || [[""]];
    return (
      <div className="overflow-x-auto rounded-lg border border-ink/15">
        <table className="w-full text-sm">
          <tbody>
            {rows.map((row, r) => (
              <tr key={r} className="border-b border-ink/10 last:border-0">
                {row.map((cell, c) => <td key={c} className="px-3 py-1.5 border-r border-ink/10 last:border-0">{cell || <span className="text-ink-soft italic">—</span>}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  if (inputType === "rich") return <div className="text-sm text-ink whitespace-pre-wrap">{renderRichText(value) || <span className="text-ink-soft italic">Empty</span>}</div>;
  return <span>{value || <span className="text-ink-soft italic">Empty</span>}</span>;
}
